import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SidenavService } from '../../../services/util/sidenav.service';
import { Endpoint } from '../../../models/endpoint';
import { animate, style, transition, trigger } from '@angular/animations';
import { EndpointType } from 'src/app/models/endpoint-type';

@Component({
    selector: 'app-view-endpoints',
    templateUrl: './view-endpoints.component.html',
    styleUrls: ['./view-endpoints.component.scss'],
    animations: [
        trigger('toastMessage', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(600, style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate(300, style({ opacity: 0 }))
            ]),
        ])
    ],
    standalone: false
})
export class ViewEndpointsComponent implements OnInit {

  @Input() title: string;
  @Input() endpoints: Endpoint[];
  @Input() instanceName: string;
  showCopiedToast: boolean;
  EndpointType: EndpointType;
  arrangedEndpoints: Endpoint[] = [];

  constructor(public sidenavService: SidenavService) { }

  ngOnInit(): void {
    this.reoderEndPoints();
  }

  reoderEndPoints(): void {
    this.endpoints.forEach((endpoint, i) => {
      if (endpoint.useType === EndpointType.UI) {
        endpoint.order = 1;
      } else if (endpoint.useType === EndpointType.CONFIGURATION) {
        endpoint.order = 2;
      } else if (endpoint.useType === EndpointType.API) {
        endpoint.order = 3;
      } else if (endpoint.useType === EndpointType.OTHER) {
        endpoint.order = 4;
      }
      this.arrangedEndpoints.push(endpoint);

    });
    this.arrangedEndpoints.sort((currentOrder, nextOrder) => currentOrder.order - nextOrder.order);
  }

  closeToast(): void {
    this.showCopiedToast = false;
  }
}
